import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getWard, deleteWard } from "service/api";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

function DatatableTables() {
    const[alluserlist,setallusers] = useState({ users: [] });
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

    useEffect(()  => {
        getallusers();
    }, []);

    const getallusers = async () => {
        let response = await getWard();
        if (response.error) {
            console.log('Error while fetching data:', response.error);      
        } else {
            setallusers({users: response.data});
        }
    }
const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setSelectedDeleteId(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    try {
      await deleteWard(selectedDeleteId);
      toast.success("Ward deleted successfully");
      getallusers();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete ward");
    } finally {
      closeDeleteModal();
    }
  };


    const columns = useMemo(
        () => [
            {
                Header: 'Ward',
                accessor: 'ward',
            },
            // {
            //     Header: 'Region',
            //     accessor: 'region'
            // },
            // {
            //     Header: 'Mobile',
            //     accessor: 'mobile'
            // },
            // {
            //     Header: 'Role',
            //     accessor: 'userType'
            // },
            {
                Header: "Action",
                Cell: ({ row }) => {
                  const id = row.original._id; 
                  return (
                    <>
                      <button className="btn btn-danger mx-2"
                   onClick={() => openDeleteModal(id)}
                    > <i className="mdi mdi-trash-can font-size-15"></i> </button>
                    </>
                  )
                },
              },
        ],
        []
    );
    //meta title
    document.title = "Ward | List";

    return (
        <div className="page-content">
            <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4">
             <h1 className="page-title"></h1>
             <Link to="/add_ward" className="btn btn-primary">ADD NEW WARD</Link>
            </div>
                <Breadcrumbs title="Setting" breadcrumbItem="Ward" />
                <TableContainer
                        columns={columns}
                        data={alluserlist.users}
                        isGlobalFilter={true}
                        isAddOptions={false}  
                        customPageSize={10}
                        className="custom-header-css"
                />
        {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}  
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
        <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal} centered>
          <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this ward?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
            <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
            </div>
        </div>
    );
}

export default DatatableTables;